// src/events/event-handler.ts
var SessionClosedReason = /* @__PURE__ */ ((SessionClosedReason2) => {
  SessionClosedReason2["Broken"] = "broken";
  SessionClosedReason2["RemoteClosed"] = "remoteclosed";
  return SessionClosedReason2;
})(SessionClosedReason || {});

export {
  SessionClosedReason
};
